module.exports = __webpack_public_path__ + "static/media/search-line.dbe67552.svg";